import { Button } from '@karnov/kui-react'

import { useTranslation } from 'services/i18n'

import type { FC } from 'react'

type Props = {
  onClick: VoidFunction
}

export const DismissCarouselButton: FC<Props> = ({ onClick }) => {
  const { t } = useTranslation()

  return (
    <Button variant="primary" onClick={onClick}>
      {t('user_carousels.dismiss')}
    </Button>
  )
}
